import { Text, Box, Image, Link } from '@chakra-ui/react';

interface HoverTileProps {
    title: string;
    image: string;
    href: string;
}

export const HoverTile: React.FC<HoverTileProps> = ({ title, image, href }) => {
    return (
        <Link href={href} title={title} target="_blank" _hover={{ textDecoration: 'none' }}>
            <Box
                bg="#eee"
                p={3}
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                aspectRatio={'1'}
                border={'1px solid #eee'}
                mixBlendMode={'multiply'}
                _hover={{
                    bg: 'white',
                    border: '1px solid #eee',
                }}
            >
                <Image src={image} alt={title} objectFit="contain" />
            </Box>
        </Link>
    );
};
